var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { useResultCategoryOutletContext } from '@/components/results-category/hooks/use-result-category-outlet-context.hook';
import { HearingResultsPopup } from '@/components/results-category/components/hearing-results-popup.component';
import { EargoButton } from '@/components/eargo-button.component';
import { ContentBlock } from '@/components/results-category/components/content-block.component';
import { supportContactInformation } from '@/constants/support.constant';
function Heading() {
    return (_jsxs("span", __assign({ className: 'inline-block leading-10 text-center md:w-full max-w-3xl font-normal' }, { children: ["Your hearing test results show that you may have", ' ', _jsx("span", __assign({ className: 'font-extrabold text-eargo-earth-yellow' }, { children: "mild-to-moderate hearing loss." }))] })));
}
export function MildHearingLossResults() {
    useResultCategoryOutletContext({
        heading: _jsx(Heading, {}),
        step: 2,
    });
    return (_jsxs("div", __assign({ className: 'h-full flex flex-col justify-between gap-5 px-4 md:px-10 md:-mt-12' }, { children: [_jsx(HearingResultsPopup, {}), _jsxs(ContentBlock, { children: [_jsxs(Typography, __assign({ className: "text-lg font-bold" }, { children: ["You may be a good candidate for Eargo.", _jsx("br", {}), "OTC hearing aids are designed for mild to moderate hearing loss."] })), _jsx(EargoButton, __assign({ className: 'text-white bg-eargo-sinopia rounded-full w-full md:w-1/2 items-center py-3', fullWidth: true, href: supportContactInformation.phone.href, target: "_blank" }, { children: "Speak to our team" }))] }), _jsx(EargoButton, __assign({ variant: 'outlined', className: 'rounded-full w-full md:w-1/2 items-center py-3 self-center', fullWidth: true, href: 'https://www.eargo.com', target: '_blank' }, { children: "Learn more about Eargo" }))] })));
}
